
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-7df4dd3f&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./addItem.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./addItem.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-7df4dd3f!../../node_modules/vue-loader/lib/selector?type=template&index=0!./addItem.vue"),
  /* scopeId */
  "data-v-7df4dd3f",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/addItem.vue
// module id = 608
// module chunks = 1